import src from "IMAGE";
export default { src, width: 1920, height: 741, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAIUlEQVR42n3KoQEAAAzCsNrx/8EzGBCIVgXgRsJbKHRjPSmLAN7jW9gtAAAAAElFTkSuQmCC"};
